import gql from 'graphql-tag'
import { Fragment } from './fragment'

export const query = gql`
  ${Fragment}
  query fetchAppraisalExternalOffer($id: Int!) {
    records: purchase_appraisal_external_offer_by_pk(id: $id) {
      ...AppraisalExternalOfferForm
    }
  }
`

export default query
